<template>
  <div id="RemoteHands">
    <div class="thred">
      <MyHeaderPage
        :title="'Ticket ' + ticket.ticketNumber"
        :subtitle="$t('remoteHands.subTitleDetails')"
      />
      <div class="navigation-container">
        <TicketsBackLink />
      </div>
      <div class="contentFormTwoCol">
        <div class="detail-box-container">
          <DetailBox
            :ticket="ticket"
            type="remotehands"
            :theme="['boxRhDetails', { contentPrimaryMobile: IsMobile }]"
          />
          <div class="pdf-download-button" v-if="ticket.cf_list">
            <button
              class="cdlButtonGreen pdf-button"
              v-tooltip:top.tooltip="
                ticket.cf_list.cf_activity_completed !== 'true'
                  ? $t('remoteHands.noPdf')
                  : ticket.pdf_downloadable === false
                  ? $t('orders.noAvaiblePdf')
                  : ''
              "
              @click="downloadPdf"
              :disabled="
                ticket.cf_list.cf_activity_completed !== 'true' ||
                ticket.pdf_downloadable === false ||
                isLoading
              "
              :class="{
                'disabled-button':
                  ticket.cf_list.cf_activity_completed !== 'true' ||
                  ticket.pdf_downloadable === false ||
                  isLoading,
              }"
            >
              <DownloadPdf class="download-icon" />
              <span>{{ $t("remoteHands.downloadPdf") }}</span>
            </button>
          </div>
        </div>
        <div class="contentSecondary noPadding minHeightThreads">
          <Threads
            :headers="headerThread"
            :ticket="ticket"
            :threads="threads"
            :attachs="attachs"
            @update="getThreads"
          />
        </div>
      </div>
    </div>

    <br /><br />
    <MyLoading :viewLoader="viewLoader" type="full" />
  </div>
</template>

<script>
import MyHeaderPage from "@/components/MyHeaderPage.vue";
import Threads from "@/components/Threads.vue";
import "@/assets/scss/RemoteHands.scss";
import "@/assets/scss/Tables.scss";
import MyLoading from "@/components/MyLoading.vue";
import TicketsBackLink from "@/components/Tickets/BackLink.vue";
import DetailBox from "@/components/Tickets/Detail/DetailBox.vue";
import DownloadPdf from "@/components/svg/DownloadPdf.vue";

export default {
  name: "RemoteHandsDetails",
  components: {
    MyHeaderPage,
    MyLoading,
    Threads,
    TicketsBackLink,
    DetailBox,
    DownloadPdf,
  },
  data() {
    return {
      ticket: {},
      threads: {},
      attachs: {},
      headerThread: {
        // ticketNumber: '###',
        createdTime: "###",
        modifiedTime: "###",
      },
      viewLoader: false,
      isLoading: false,
      he: {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      },
      IsMobile: this.$IsMobile(),
    };
  },
  methods: {
    downloadPdf() {
      if (
        this.ticket.cf_list &&
        this.ticket.cf_list.cf_activity_completed === "true" &&
        this.ticket.pdf_downloadable === true
      ) {
        this.isLoading = true;

        this.axios
          .get(
            window.VUE_APP_MISTRA_URL +
              "tickets/v1/ticket/pdf" +
              "?ticket_id=" +
              this.$route.params.id +
              "&ticket_type=RemoteHands",
            {
              headers: this.he,
              responseType: "blob",
            }
          )
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `ticket_${this.ticket.ticketNumber}.pdf`
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.isLoading = false;
          })
          .catch((error) => {
            console.error("Error downloading PDF:", error);
            this.isLoading = false;
          });
      }
    },
    getThreads() {
      this.viewLoader = false;
      this.axios
        .get(
          window.VUE_APP_MISTRA_URL +
            "tickets/v1/ticket-threads-by-ticket-number/?ticket_number=" +
            this.$route.params.id,
          { headers: this.he }
        )
        .then((response) => {
          this.threads = response.data;
          if (response.data.threadAttachments) {
            this.attachs = response.data.threadAttachments;
          }
          this.viewLoader = true;
        });
    },
  },
  mounted() {
    window.scrollTo(0, 0);

    this.ticket.ticket_id = this.$route.params.id;

    let getTicket = new Promise((resolve) => {
      this.axios
        .get(
          window.VUE_APP_MISTRA_URL +
            "tickets/v1/ticket/?ticket_id=" +
            this.$route.params.id +
            "&ticket_type=RemoteHand",
          { headers: this.he }
        )
        .then((response) => {
          this.ticket = response.data.res;
          // Set pdf_downloadable property based on ticket status
          if (
            this.ticket.cf_list &&
            this.ticket.cf_list.cf_activity_completed === "true"
          ) {
            this.ticket.pdf_downloadable = true;
          } else {
            this.ticket.pdf_downloadable = false;
          }
          for (const [key, value] of Object.entries(this.ticket)) {
            if (Object.prototype.hasOwnProperty.call(this.headerThread, key)) {
              this.headerThread[key] = value;
            }
          }
          resolve(true);
        });
    });

    Promise.all([getTicket]).then((values) => {
      if (values[0]) {
        this.getThreads();
      }
    });
  },
};
</script>

<style>
.pdf-button.disabled-button {
  opacity: 0.6;
  cursor: not-allowed;
  .cls-1 {
    fill: white;
  }
}
</style>

<style scoped lang="scss">
.navigation-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.detail-box-container {
  position: relative;
}

.pdf-download-button {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 10;
}

.pdf-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 15px;
  border-radius: 20px;
  font-size: 14px;
  width: auto;
}

.download-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.download-icon path {
  fill: white;
}
</style>
